import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAdminAuthenticated } from '../../utils/adminAuth';
import AnalyticsPage from '../AnalyticsPage/AnalyticsPage';

const AdminPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdminAuthenticated()) {
      navigate('/admin/login');
    }
  }, [navigate]);

  if (!isAdminAuthenticated()) {
    return null; // Will redirect
  }

  return <AnalyticsPage />;
};

export default AdminPage;

